/**
 * dealNav.ts — the deal page's place in the board's order (deal detail slice
 * 1, §39.9; spec §3.1): "Deal 2 of 9", the ‹ › buttons and J / K. Pure, so
 * vitest pins it without a DOM.
 *
 * The order is the Pipeline board's DISPLAY order (lanes left to right, each
 * lane as sorted), carried with the card open. A deal opened from anywhere
 * else — Home, a lead convert, an account 360 — has no order, so it has no
 * position and no stepping; nothing is guessed from a list the user did not
 * see.
 */
export interface DealPosition {
  /** 1-based, as shown. */
  index: number
  total: number
  prevId: string | null
  nextId: string | null
}

export function dealPosition(order: readonly string[] | null | undefined, id: string): DealPosition | null {
  if (!order || order.length === 0) return null
  const i = order.indexOf(id)
  if (i < 0) return null
  return {
    index: i + 1,
    total: order.length,
    prevId: i > 0 ? order[i - 1] : null,
    nextId: i < order.length - 1 ? order[i + 1] : null,
  }
}

/** J = next, K = previous (the list-navigation convention the spec names). */
export const DEAL_NEXT_KEY = 'j'
export const DEAL_PREV_KEY = 'k'
